import React from 'react';
import { FaLeaf, FaInstagram, FaEnvelope, FaWhatsapp, FaFacebook } from 'react-icons/fa';
import { useStateContext } from '../contexts/ContextProvider';

const Footer = () => {
  const { currentMode, currentColor } = useStateContext();

  const isDark = currentMode === 'Dark';
  const accentColor = currentColor || '#c9862a';

  const bgColor = isDark ? '#1a1a18' : '#f7f3ec';
  const borderColor = isDark ? '#2e2e28' : '#e8e0d0';
  const textPrimary = isDark ? '#f0ece3' : '#1a1a18';
  const textSecondary = isDark ? '#a09880' : '#6b6456';

  return (
    <footer
      className="border-t flex-shrink-0"
      style={{
        backgroundColor: bgColor,
        borderColor: borderColor,
        borderTopWidth: '3px',
        borderTopColor: accentColor,
      }}
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 px-6 md:px-10 py-4">
        {/* Brand */}
        <div className="flex items-center gap-3">
          <div
            className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded"
            style={{ backgroundColor: accentColor }}
          >
            <FaLeaf className="text-white text-xs" />
          </div>
          <div>
            <span
              className="font-serif text-sm font-bold"
              style={{ color: textPrimary }}
            >
              Rumoh Pangan{' '}
            </span>
            <span
              className="font-serif text-sm font-bold"
              style={{ color: accentColor }}
            >
              Aceh
            </span>
          </div>
          <div
            className="h-4 w-px"
            style={{ backgroundColor: borderColor }}
          />
          <span
            className="text-xs"
            style={{ color: textSecondary }}
          >
            © {new Date().getFullYear()}
          </span>
        </div>

        {/* Center links */}
        <div className="hidden md:flex items-center gap-5">
          {['Program', 'Etalase', 'Petani', 'Laporan'].map((item, i, arr) => (
            <React.Fragment key={item}>
              <a
                href="#"
                className="text-xs font-medium transition-colors duration-200 hover:opacity-80"
                style={{ color: textSecondary }}
                onMouseEnter={(e) => (e.target.style.color = accentColor)}
                onMouseLeave={(e) => (e.target.style.color = textSecondary)}
              >
                {item}
              </a>
              {i < arr.length - 1 && (
                <div
                  className="w-1 h-1 rounded-full"
                  style={{ backgroundColor: borderColor }}
                />
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Right: social + tagline */}
        <div className="flex items-center gap-3">
          <span
            className="text-[10px] tracking-widest uppercase hidden sm:block"
            style={{ color: textSecondary }}
          >
            Ketahanan Pangan Aceh
          </span>
          <div
            className="h-4 w-px hidden sm:block"
            style={{ backgroundColor: borderColor }}
          />
          {[
            { icon: <FaInstagram size={13} />, href: '#', label: 'Instagram' },
            { icon: <FaWhatsapp size={13} />, href: '#', label: 'WhatsApp' },
            { icon: <FaEnvelope size={13} />, href: '#', label: 'Email' },
            { icon: <FaFacebook size={13} />, href: '#', label: 'Facebook' },
          ].map(({ icon, href, label }) => (
            <a
              key={label}
              href={href}
              aria-label={label}
              className="w-7 h-7 flex items-center justify-center transition-all duration-200 hover:scale-110"
              style={{
                border: `1px solid ${borderColor}`,
                color: textSecondary,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = accentColor;
                e.currentTarget.style.color = accentColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = borderColor;
                e.currentTarget.style.color = textSecondary;
              }}
            >
              {icon}
            </a>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div
        className="px-6 md:px-10 py-3 border-t"
        style={{
          borderColor: borderColor,
          backgroundColor: isDark ? '#242420' : `${accentColor}08`,
        }}
      >
        <div className="flex flex-col md:flex-row justify-between items-center gap-2">
          <p className="text-xs" style={{ color: textSecondary }}>
            <span style={{ color: accentColor }}>Rumoh Pangan Aceh</span> — Organisasi Ketahanan Pangan Rakyat
          </p>
          <p className="text-xs" style={{ color: textSecondary }}>
            Banda Aceh, Indonesia
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;